import ky from 'ky';

const shop = ky.create({
    retry: {
        limit: 0,
    },
});

export default shop;
